import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { CHART_INK } from './agencyChartTheme';
import { DEFINITION_PARTS, IOutcomeDefinition } from '@innerhive-internal/innerhive-common';

const useStyles = createUseStyles({
    parts: {
        margin: 0
    },

    part: {
        marginTop: 10,

        '&:first-child': {
            marginTop: 0
        }
    },

    heading: {
        fontSize: 11.5,
        fontWeight: 600,
        letterSpacing: '0.03em',
        textTransform: 'uppercase' as const,
        color: CHART_INK.label
    },

    body: {
        margin: '3px 0 0',
        fontSize: 12.5,
        lineHeight: 1.55,
        color: CHART_INK.strongLabel
    }
});

/**
 * How a figure is counted, in full, behind the tip on the list the figure opens into: a reader
 * putting a figure in front of somebody else needs the whole definition, not the sentence the
 * Outcomes Report's own tip gives each figure.
 */
export const OutcomeDefinition: FC<{ definition: IOutcomeDefinition }> = ({ definition }) => {
    const classes = useStyles();

    return (
        <dl className={classes.parts} data-id="outcome-definition">
            {DEFINITION_PARTS.map(part => (
                <div key={part.key} className={classes.part} data-id="outcome-definition-part" data-part={part.key}>
                    <dt className={classes.heading}>{part.heading}</dt>
                    <dd className={classes.body}>{definition[part.key]}</dd>
                </div>
            ))}
        </dl>
    );
};
